import { Component, Vue } from 'vue-property-decorator';
import store from "Store/index";


@Component
export default class OrderingListMixin extends Vue 
{
    scopeIsOrderingList: boolean = false;
    scopeIsYourSortimentList: boolean = false; 
    scopeIsFavoriteList: boolean = false;

    async created() {
        const scopeIsOrderingList = document.getElementById('scope_is_orderinglist');
        if(scopeIsOrderingList)
        {
            this.scopeIsOrderingList = scopeIsOrderingList.innerHTML == "1";
        }

        const scopeIsFavoriteList = document.getElementById('scope_is_favoritelist');
        if(scopeIsFavoriteList)
        {
            this.scopeIsFavoriteList = scopeIsFavoriteList.innerHTML == "1";
        }

        const scopeIsYourSortimentList = document.getElementById('scope_is_yoursortiment');
        if(scopeIsYourSortimentList)
        {
            this.scopeIsYourSortimentList = scopeIsYourSortimentList.innerHTML == "1";
        }
    }
    
}
